<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {getCodToAccessory, getSelectedCity, isFavorite} from "../../utils";
    import {AccessoryStockItem, IPriceResponse, IProductPreview} from "../../interfaces";
    import CircularProgress from '@smui/circular-progress';
    import {createEventDispatcher, onMount} from "svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    declare const httpPromise: any;

    const dispatch = createEventDispatcher();

    let price: IPriceResponse;

    export let data: IProductPreview;
    export let loadingPrice: boolean = false;
    let flag: string;


    const formatter = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    });

    let dialog: any = {
        open: false,
        message: ''
    }

    onMount(() => {
        setTimeout(() => {
            queryPrice();
        }, 100);
    });

    async function queryPrice() {
        if (data.price_payload) {
            loadingPrice = true;
            const url = new URL('/backend/servicio/precio-disponibilidad/', location.origin);
            url.search = new URLSearchParams(data.price_payload).toString();
            fetch(url.toString(), {
                method: 'GET'
            }).then(r => r.json()).then((response) => {
                data.price = response.prices[0].precioNeto;
                price = response.prices[0];
                if (!price) {
                    throw new Error('No se encontró precio')
                } else {
                    loadingPrice = false;
                }
            }).catch((error) => {
                data.price_payload.incluyeInstalacion = 1;
                url.search = new URLSearchParams(data.price_payload).toString();
                fetch(url.toString(), {
                    method: 'GET'
                }).then(r => r.json()).then((response) => {
                    data.price = response.prices[0].precioNeto;
                    price = response.prices[0];
                    price.tipo = 'P';
                    loadingPrice = false;
                }).catch((error) => {
                    console.error('error consultando precio', error)
                    data.price = null;
                    price = null;
                    loadingPrice = false;
                });
            });
        }
        return null
    }

    async function addToFavorites() {
        const fav = {
            item_type: data.type,
            item_id: data.referencia
        };
        localStorage.setItem('favorito-cache', JSON.stringify(fav));
        httpPromise({
            url: '/backend/servicio/agregar-favorito/',
            method: 'POST',
            data: fav
        }).then((response) => {
            localStorage.setItem('favoritos', JSON.stringify(response.favoritos));
            localStorage.removeItem('favorito-cache');
            data = data;
        }).catch((err) => {
            dialog.message = err.message;
            dialog.open = true;
        });
    }

    function getFavoriteIcon(data) {
        if (isFavorite(data)) {
            return '/static/storefront/pix/icons/agregado-favoritos.svg'
        }
        return '/static/storefront/pix/icons/agregar-favoritos.svg';
    }

    function addToCart() {
        const {type, meta} = data;
        if (meta) {
            const manager = ManagerVehicles.getInstance();
            const selectedVehicle = manager.selected;
            const selectedCity = getSelectedCity();
            let path = [];
            switch (type) {
                case 'Repuesto':
                    path = ['', 'repuesto', meta?.slug];
                    dispatch('add', {
                        price: price.precioNeto,
                        prevPrice: price.precio_total,
                        flag: price.porcDescuento && price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                        tiempoDespacho: price.tiempoDespacho,
                        quantity: 1,
                        disponibilidad: price.disponibilidad ? 1 : 0,
                        item: {
                            id: meta.id,
                            type: 'R',
                            image: data.image ?? '',
                            name: meta.nombre,
                            reference: meta.cod_referencia,
                            delivery: true,
                            codModelo: selectedVehicle?.codModeloTASA ?? '',
                            route: path.join('/')
                        },
                        city: {
                            id: selectedCity
                        },
                        tipo: price.tipo,
                        price_payload: data.price_payload,
                        meta: meta,
                        price_obj: price
                    });
                    break;
                case 'Boutique':
                    path = ['', 'boutique', meta?.slug]
                    dispatch('add', {
                        item: {
                            id: meta.id,
                            name: meta.nombre,
                            reference: meta.cod_referencia,
                            type: 'Z',
                            codModeloTasa: selectedVehicle?.codModeloTASA ?? '',
                            image: meta.thumbnail ?? '',
                            vin: selectedVehicle?.vin ?? '',
                            route: path.join('/')
                        },
                        prevPrice: price.precio_total,
                        price: price.precioNeto,
                        flag: price.porcDescuento && price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                        quantity: 1,
                        city: {
                            id: selectedCity
                        }
                    });
                    break;
                case 'Accesorio':
                    const {link_imagen, imagen_thumbnail} = meta.imagenes.length > 0 ? meta.imagenes[0] : {}
                    path = ['', 'accesorio'];
                    if (meta.brand?.slug) {
                        path.push(meta.brand.slug);
                        if (meta.linea?.slug) {
                            path.push(meta.linea.slug);
                            path.push(meta.slug)
                        }
                    }
                    if (price.tipo === 'P') {
                        const a: AccessoryStockItem = {
                            item: {
                                id: meta.id,
                                type: 'P',
                                image: link_imagen ?? imagen_thumbnail,
                                name: meta.nombre,
                                description: meta.descripcion,
                                delivery: false,
                                reference: price.codReferencia,
                                codModelo: getCodToAccessory(meta?.linea),
                                installationEnabled: meta.instalacion_habilitada,
                                route: path.join('/')
                            },
                            city: {
                                id: selectedCity
                            },
                            installation: true,
                            isNew: false,
                            vin: selectedVehicle?.vin ?? '',
                            placa: selectedVehicle?.placa ?? '',
                            prevPrice: price.precio_total,
                            price: price.precioNeto,
                            flag: price.porcDescuento && price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                            quantity: 1,
                            byOrder: false,
                            tipo: price.tipo,
                            price_payload: data.price_payload,
                            meta: meta,
                            price_obj: price
                        }
                        dispatch('add', a);
                    } else {
                        const a = {
                            price: price.precioNeto,
                            prevPrice: price.precio_total,
                            flag: price.porcDescuento && price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                            tiempoDespacho: price.tiempoDespacho,
                            quantity: 1,
                            disponibilidad: price.disponibilidad ? 1 : 0,
                            item: {
                                id: meta.id,
                                type: 'P',
                                image: data.image ?? '',
                                name: meta.nombre,
                                reference: price.codReferencia,
                                delivery: true,
                                codModelo: getCodToAccessory(meta?.linea),
                                route: path.join('/')
                            },
                            city: {
                                id: selectedCity
                            },
                            tipo: price.tipo,
                            price_payload: data.price_payload,
                            meta: meta,
                            price_obj: price
                        }
                        dispatch('add', a);
                    }
                    break;
                case 'Servicio':
                    path = ['', 'servicio', meta?.slug];
                    dispatch('add', {
                        item: {
                            id: meta.id,
                            name: meta.nombre,
                            reference: meta.cod_referencia,
                            type: 'S',
                            codModeloTasa: selectedVehicle?.codModeloTASA ?? '',
                            image: meta.thumbnail ?? '',
                            vin: selectedVehicle?.vin ?? '',
                            route: path.join('/')
                        },
                        prevPrice: price.precio_total,
                        price: price.precioNeto,
                        flag: price.porcDescuento && price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                        quantity: 1,
                        installation: true,
                        city: {
                            id: selectedCity
                        }
                    })
                    break;
                default:
                    console.warn(`type: ${type}`);
                    break;
            }
        }
    }
</script>
<div class="productPreview mb-1">
    <div class="box relative">
        <a href={data.route}>
            {#if data.image}
                <img class="w-100" src="{data.image}" alt="{data.name}">
            {:else}
                <img class="w-100" src="/static/storefront/pix/no_foto.jpg" alt="{data.name}">
            {/if}
        </a>
        <div class="absolute favorite" on:click={addToFavorites}>
            <img height="35" src={getFavoriteIcon(data)} alt="Agregar a favoritos">
        </div>
        {#if price?.porcDescuento > 0}
            <div class="discount absolute">
                DCTO {price.porcDescuento}%
            </div>
        {/if}
    </div>
    {#if data?.brand}
        <div class="brand">{data.brand}</div>
    {/if}
    <div class="name">{data.name}</div>
    <div class="grid-1-auto">
        <div>
            {#if data.type}
                <div class="type">{data.type}</div>
            {/if}
            {#if data.price_payload}
                {#if loadingPrice}
                    <CircularProgress style="height: 18px; width: 18px;" indeterminate/>
                {:else if data.price >= 0 && typeof data.price == 'number'}
                    <div class="price">{formatter.format(data.price)}</div>
                {:else}
                    <div class="price">NO DISPONIBLE</div>
                {/if}
            {/if}
        </div>
        <div>
            {#if price}
                <div class="btn-cart box bg-accent">
                    <img height="21"
                         src="/static/storefront/pix/icons/carrito-blanco.svg"
                         alt="Agregar al carrito"
                         on:click={()=>addToCart()}>
                </div>
            {/if}
        </div>
    </div>
</div>
<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-1 w-100">
            <NauiButton caption="INICIAR SESIÓN"
                        color="accent"
                        mode="solid"
                        href="/iniciar-sesion"/>
            <NauiButton caption="CANCELAR"
                        color="accent"
                        mode="solid"
                        on:click={() => {dialog.open = false;}}/>
        </div>
    </Actions>
</Dialog>
<style>
    .favorite {
        right: .5rem;
        top: .5rem;
    }

    .brand {
        font-size: 12px;
        text-transform: uppercase;
        margin: .25rem 0;
    }

    .name {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: .25rem;
    }

    .type {
        background: var(--bg-gray);
        width: max-content;
        padding: .25rem;
        font-size: 12px;
        font-weight: 600;
        color: var(--text-gray);
        margin-bottom: .25rem;
    }

    .price {
        font-size: 18px;
    }

    .btn-cart {
        height: 45px;
        width: 45px;
        border-radius: 50%;
        cursor: pointer;
    }

    .discount {
        font-size: 12px;
        background: black;
        padding: .25rem;
        bottom: 0;
        left: 0;
        color: white;
        font-weight: 600;
    }
</style>